import { render, staticRenderFns } from "./OraclesModal.vue?vue&type=template&id=22f8d1a2&lang=pug&"
import script from "./OraclesModal.vue?vue&type=script&lang=js&"
export * from "./OraclesModal.vue?vue&type=script&lang=js&"
import style0 from "./OraclesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports